import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var Queue = /*#__PURE__*/function () {
  function Queue(maxSize) {
    _classCallCheck(this, Queue);
    this.queue = [];
    this.maxSize = maxSize;
  }
  return _createClass(Queue, [{
    key: "enqueue",
    value: function enqueue(item) {
      if (this.queue.length === this.maxSize) {
        return false;
      }
      this.queue.push(item);
      return true;
    }
  }, {
    key: "flush",
    value: function flush(callback) {
      this.queue.forEach(callback);
      this.queue = [];
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.queue.length;
    }
  }]);
}();
export { Queue as default };